import BoardContainer from "../board/BoardContainer";

const categories = [
  { postType: 'PT02', title: '전체', sectionTitle: '전체' },
  { postType: 'PT020', title: '정보 공유', sectionTitle: '정보 공유' },
  { postType: 'PT021', title: '셀러 정보 공유', sectionTitle: '셀러 정보 공유' },
];

const Information = () => {
  return (
    <BoardContainer postType="PT02" postSectionTitle="정보광장" categories={categories} />
  );
}

export default Information;